export const Success : string ="Success";
export const AlreadySent : string ="Already Sent";